

























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {FieldTooltip} from "wings-ui-components";

@Component({components: { FieldTooltip }})
export default class CascadingOptions extends Vue {
  @Prop({ required: true }) templateItem!: any;
  @Prop({ required: true }) isCascading!: boolean;
  @Prop({ required: true }) errors!: { [key: string]: string[] };

  get isCancelEnabled(): boolean {
    return !!this.templateItem.multichannel_cancel_by_status;
  }

  @Watch('isCascading', { immediate: false })
  onChangeIsCascading(val?: boolean) {
    if(!val){
      this.templateItem.multichannel_cancel_by_status = 0;
      this.templateItem.multichannel_cancel_statuses = [];
    }
  }

  @Watch('templateItem.multichannel_cancel_by_status', {immediate: false, deep: true})
  onChangeCancelByStatus(val?: number) {
    if (val && this.templateItem.multichannel_cancel_statuses?.length === 0) {
      this.templateItem.multichannel_cancel_statuses = [3];
    } else if (!val) {
      this.templateItem.multichannel_cancel_statuses = [];
    }
  }
}
